<template>
  <div class="d-flex flex-column">
    <EquipmentCard
      v-for="equipment in equipmentData"
      :key="equipment.id"
      v-bind="equipment"
      :address="fullAddress(equipment.address)"
      :equipment-type-name="equipment.equipment_type_name"
      :service-history="equipment.service_history"
      show-service-history
      default-collapsed
      :components="activeComponents(equipment.components)"
      class="mb-4"
      :class="{ highlighted: isSelected(equipment) }"
      :data-cy="`equipment-card-${equipment.id}`"
      @edit="emit('edit-equipment', equipment)"
    >
      <template #componentsTable>
        <EquipmentComponentsTable
          :components="activeComponents(equipment.components)"
        />
      </template>
      <template #serviceHistoryTable>
        <EquipmentServiceHistoryTable
          :service-history="equipment.service_history"
        />
      </template>
    </EquipmentCard>
    <div v-if="!equipmentData.length" class="no-results-message">
      <i class="fa-solid fa-screwdriver-wrench"></i>
      No Customer Equipment
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { getQueryVariables } from "@/lib/url.js";

import EquipmentComponentsTable from "@/ComponentTypes/EquipmentComponentsTable.vue";
import EquipmentServiceHistoryTable from "@/Equipment/EquipmentServiceHistoryTable.vue";
import { Equipment } from "@/typings/equipment";

const store = useStore();
const emit = defineEmits(["edit-equipment"]);
defineProps<{
  equipmentData: Equipment[];
}>();

const isSelected = (equipment) => {
  const { equipment_id, component_id } = getQueryVariables();
  // Match on equipment id
  if (equipment_id) {
    return equipment.id.toString() === equipment_id;
  }
  // Match on nested component id
  if (component_id) {
    return equipment.components.some(
      (comp) => comp.id.toString() === component_id
    );
  }
};

const activeComponents = (components) => {
  return (components || []).filter((comp) => !comp.archived);
};
</script>

<style lang="scss" scoped>
.highlighted {
  box-shadow: 0 0 15px var(--primary-color) !important;
}
</style>
